export default "__VITE_ASSET__691b14d3__"